export default "__VITE_ASSET__B7akRZGD__"